import React from "react";
import Moment from "moment";
import forwardDirection from "../../assets/images/estimate/next.png";
import { getBoxesCount, getTotalItemsCount } from "../inventory/InventoryHelper";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import navigationLinks from "../../constants/navigation_links";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Info from "../../assets/images/icons/info.png";

function MoveInfo(props) {
  const history = useHistory();
  const moveInfo = useSelector((state) => state.moveInfo);
  const inventory = useSelector((state) => state.inventoryInfo);
  const propertyInfo = useSelector((state) => state.propertyInfo);
  const moveInfoData = {};
  moveInfoData["from"] =
    moveInfo.moveType === "Within City"
      ? moveInfo.withinCityMovingFrom
      : moveInfo.interCityMovingFrom;
  moveInfoData["to"] =
    moveInfo.moveType === "Within City"
      ? moveInfo.withinCityMovingTo
      : moveInfo.interCityMovingTo;
  moveInfoData["propertySize"] =
    moveInfo.moveType === "Within City"
      ? moveInfo.withinCityPropertySize
      : moveInfo.interCityPropertySize;
  moveInfoData["distance"] =
    moveInfo.moveType === "Within City"
      ? moveInfo.withinCityDistance
      : moveInfo.interCityDistance;
  const moveDate =
    moveInfo.moveType === "Within City"
      ? Moment(new Date(moveInfo.withinCityMovingOnDate))
      : Moment(new Date(moveInfo.interCityMovingOnDate));

  moveInfoData["date"] = moveDate.format("DD"); //Ex: 01 02 ... 30 31
  moveInfoData["month"] = moveDate.format("MMM"); //Ex: Jan,Feb..
  moveInfoData["year"] = moveDate.format("YYYY"); // Ex:2020.2019..
  moveInfoData["totalItems"] = getTotalItemsCount(inventory);

  const fromAddress = `${propertyInfo["oldHouseAddress"]}, ${propertyInfo["oldHouseLocation"]}, ${propertyInfo["oldHouseCity"]}, ${propertyInfo["oldHouseState"]} ${propertyInfo["oldHousePincode"]}`;
  const toAddress = `${propertyInfo["newHouseAddress"]}, ${propertyInfo["newHouseLocation"]}, ${propertyInfo["newHouseCity"]}, ${propertyInfo["newHouseState"]}, ${propertyInfo["newHousePincode"]}`;
  //from house info
  const oldFloorNumber = propertyInfo["oldFloorNumber"];
  const oldHouseHasElevator = propertyInfo["oldHouseHasElevator"];
  const oldHouseDistance = `${Math.floor(propertyInfo["oldHouseDistance"])} ${propertyInfo["oldHouseDistanceUnit"]
    }`;
  //to house info
  const newFloorNumber = propertyInfo["newFloorNumber"];
  const newHouseHasElevator = propertyInfo["newHouseHasElevator"];
  const newHouseDistance = `${Math.floor(propertyInfo["newHouseDistance"])} ${propertyInfo["newHouseDistanceUnit"]
    }`;

  const totalItemsCount = parseInt(getTotalItemsCount(inventory));
  const boxesCount = parseInt(getBoxesCount(inventory));
  const JSX = (
    <>
      <section className="move-info mb-4">
        <div>
          <div className="move-date-card">
            <div className="month">{moveInfoData.month}</div>
            <div className="date">{moveInfoData.date}</div>
            <div className="year">{moveInfoData.year}</div>
            <div className="banner-clip-right"></div>
          </div>
        </div>
        <div>
          <div className="move-data-container mb-3">
            <div>
              <h3>Property Size</h3>
              <div className="value"> {moveInfoData.propertySize}</div>
            </div>
            <div>
              <h3>Total Items</h3>
              <div className="value"> {totalItemsCount - boxesCount} </div>
            </div>
            <div>
              <h3>Boxes Required</h3>
              <div className="value"> {boxesCount} </div>
            </div>
            <div>
              <h3>Distance</h3>
              <div className="value"> {moveInfoData.distance}s* </div>
            </div>

            <div className="d-none">
              <div className="d-flex justify-content-end align-items-center">
                {/* <button className="btn btn-dark mx-2 px-4 btn-sm"></button> */}
                <button
                  className="btn btn-dark mx-2 px-4 btn-sm text-capitalize"
                  onClick={() => history.push(navigationLinks.inventory_page)}
                >
                  Edit Inventory
                </button>
                <div className="d-flex justify-content-center">
                  <button className="btn px-5 btn-sm">Submit</button>
                </div>
              </div>
            </div>
          </div>
          <div className="address-info-container">
            <div className="w-100">
              <div>
                <h3> From </h3>
                <p className="address">{fromAddress}</p>
              </div>
              <div className="property-details d-flex flex-row justify-content-between">
                <div>
                  <h4 className="property-info-title">Floor No</h4>
                  <div className="value"> {oldFloorNumber} </div>
                </div>
                <div>
                  <h4 className="property-info-title">Service Lift Available</h4>
                  <div className="value"> {oldHouseHasElevator}</div>
                </div>
                <div>
                  <h4 className="property-info-title">
                    Distance DTT{" "}
                    <>
                      <OverlayTrigger
                        key={"top"}
                        placement={"top"}
                        overlay={
                          <Tooltip id={`tooltip-${"top"}`}>
                            DTT - Door To Truck
                          </Tooltip>
                        }
                      >
                        <img src={Info} className="img-fluid mx-1" alt="" />
                      </OverlayTrigger>
                    </>{" "}
                  </h4>
                  <div className="value"> {oldHouseDistance} </div>
                </div>
              </div>
            </div>
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              <div className="direction">
                <img src={forwardDirection} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="w-100">
              <h3> To </h3>
              <p className="address">{toAddress}</p>{" "}
              <div className="property-details d-flex flex-row justify-content-between">
                <div>
                  <h4 className="property-info-title">Floor No</h4>
                  <div className="value"> {newFloorNumber} </div>
                </div>
                <div>
                  <h4 className="property-info-title">Service Lift Available</h4>
                  <div className="value"> {newHouseHasElevator} </div>
                </div>
                <div>
                  <h4 className="property-info-title">
                    Distance DTT{" "}
                    <>
                      <OverlayTrigger
                        key={"top"}
                        placement={"top"}
                        overlay={
                          <Tooltip id={`tooltip-${"top"}`}>
                            DTT - Door To Truck
                          </Tooltip>
                        }
                      >
                        <img src={Info} className="img-fluid mx-1" alt="" />
                      </OverlayTrigger>
                    </>{" "}
                  </h4>
                  <div className="value"> {newHouseDistance} </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="additonal">
        <div className="additional-data">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
              <div>
                <label for="" class="form-label">
                  <b>Any Additional Information</b>
                </label>

                <textarea
                  name="additional_info"
                  id=""
                  value={props.additionalState.additionalData}
                  cols="30"
                  rows="2"
                  onChange={(e) => {
                    const value = e.target.value;
                    props.additionalState.setAdditionalData(value);
                    return;
                  }}
                  class="form-control"
                  placeholder="Ex. Dog at home | Please call when your reach |  Collect Security pass"
                ></textarea>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 summary-action-container">
              <div className="d-flex justify-content-end align-items-center">
                {/* <button className="btn btn-dark mx-2 px-4 btn-sm"></button> */}
                <button
                  className="btn btn-dark mx-2 px-4 btn-sm text-capitalize text-nowrap"
                  onClick={() => {
                    // history.push(navigationLinks.inventory_page);
                    props.editInventoryNavFn({
                      gotoPage: navigationLinks.inventory_page,
                    });
                  }}
                >
                  Edit Inventory
                </button>
                <div className="d-flex justify-content-center">
                  {/* auth LoginModal.jsx modal handles the estimate flow submit logic.   */}
                  <button
                    className="btn px-5 btn-sm"
                    onClick={() => props.authSubmit.setLoginModal(true)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
  return JSX;
}

export default MoveInfo;
